type TExtractEventDetail<T> = T extends CustomEvent<infer X> ? X : never;

export class CustomEventTarget<
  TEvents extends Record<string, CustomEvent<any>>,
> extends EventTarget {
  constructor() {
    super();
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  public addEventListener<Key extends keyof TEvents>(
    type: Key,
    listener: (ev: TEvents[Key]) => void,
    options?: AddEventListenerOptions | boolean,
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  public removeEventListener<Key extends keyof TEvents>(
    type: Key,
    listener: (ev: TEvents[Key]) => void,
    options?: AddEventListenerOptions | boolean,
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  protected emitEvent<Key extends keyof TEvents>(
    type: Key,
    data: TExtractEventDetail<TEvents[Key]>,
  ) {
    this.dispatchEvent(new CustomEvent(type as string, { detail: data }));
  }
}
